module.exports = __webpack_public_path__ + "img/22.d0b3f0a8.jpg";